import styled, { css } from 'styled-components';
import { variant } from 'styled-system';
import { textStyles } from '../../../theme/config/typography';
import { BadgeTone } from './enums';
import { StyledBadgeProps } from './types';

const toneStyles = (tone: BadgeTone) => {
  switch (tone) {
    case BadgeTone.Success:
      return css`
        background-color: var(--success-soft);
        color: var(--success-ink);
      `;
    case BadgeTone.Warning:
      return css`
        background-color: var(--warning-soft);
        color: var(--warning-ink);
      `;
    case BadgeTone.Danger:
      return css`
        background-color: var(--danger-soft);
        color: var(--danger-ink);
      `;
    case BadgeTone.Info:
      return css`
        background-color: var(--info-soft);
        color: var(--info-ink);
      `;
    case BadgeTone.Ink:
      return css`
        background-color: var(--brand-ink);
        color: var(--surface);
      `;
    default:
      return css`
        background-color: var(--paper-2);
        color: var(--ink-2);
      `;
  }
};

export const StyledBadge = styled.div<StyledBadgeProps>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 8px;
  border-radius: var(--r-full);
  font-size: var(--t-xs);
  font-weight: 600;
  white-space: nowrap;
  line-height: 1.4;

  ${({ resolvedTone = BadgeTone.Neutral }) => toneStyles(resolvedTone)}

  ${variant({ variants: { ...textStyles } })}
`;
